import { render, staticRenderFns } from "./InstantMarketingHome.vue?vue&type=template&id=87ee4c1a&"
import script from "./InstantMarketingHome.vue?vue&type=script&lang=js&"
export * from "./InstantMarketingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports